import { useLocation } from 'react-router-dom';
import {
  FullIframeLayoutDesktopContent,
  LayoutDesktopContainer,
  LayoutDesktopContent,
} from './LayoutDesktop.styles';
import LayoutDesktopFooter from './LayoutDesktopFooter';
import LayoutDesktopHeader from './LayoutDesktopHeader';

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const LayoutDesktop = ({ children }) => {
  const { pathname } = useLocation();

  const isIframeFull =
    pathname.includes('signup') || pathname.startsWith('/register');

  if (isIframeFull)
    return (
      <FullIframeLayoutDesktopContent>
        {children}
      </FullIframeLayoutDesktopContent>
    );

  return (
    <LayoutDesktopContainer>
      <LayoutDesktopHeader />

      <LayoutDesktopContent>
        <div className="card">{children}</div>
      </LayoutDesktopContent>

      <LayoutDesktopFooter />
    </LayoutDesktopContainer>
  );
};

export default LayoutDesktop;
